export default "__VITE_ASSET__A5y$d5z7__"